import React from "react";
import { Box, Typography } from "@mui/material";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import {
  EMPTY_HUB_SUMMARY,
  HUB_TAB_ACCEPTED,
  HUB_TAB_AVAILABLE,
  HUB_TAB_FINISHED,
  HUB_TAB_IN_REVIEW,
  HUB_TAB_LOST,
} from "../carrierHub.mapper";

const SUMMARY_CARDS = [
  {
    key: HUB_TAB_AVAILABLE,
    summaryKey: "available",
    label: "Disponíveis",
    hint: "Aberto a lance ou preço fixo",
    tone: "blue",
    Icon: Inventory2OutlinedIcon,
  },
  {
    key: HUB_TAB_IN_REVIEW,
    summaryKey: "inReview",
    label: "Em análise",
    hint: "Aguardando embarcador",
    tone: "orange",
    Icon: HourglassEmptyOutlinedIcon,
  },
  {
    key: HUB_TAB_ACCEPTED,
    summaryKey: "accepted",
    label: "Aceitas",
    hint: "Você foi selecionado",
    tone: "green",
    Icon: TaskAltOutlinedIcon,
  },
  {
    key: HUB_TAB_FINISHED,
    summaryKey: "finished",
    label: "Finalizadas",
    hint: "Nos últimos 30 dias",
    tone: "navy",
    Icon: FlagOutlinedIcon,
  },
  {
    key: HUB_TAB_LOST,
    summaryKey: "lost",
    label: "Perdidas",
    hint: "Não selecionado",
    tone: "red",
    Icon: HighlightOffOutlinedIcon,
  },
];

export default function CarrierHubSummary({
  summary = EMPTY_HUB_SUMMARY,
  activeTab,
  onSelectTab,
  loading = false,
}) {
  return (
    <Box className="lances-hub-summary">
      {SUMMARY_CARDS.map((card) => {
        const Icon = card.Icon;
        const value = Number(summary?.[card.summaryKey]) || 0;
        const isActive = activeTab === card.key;

        return (
          <button
            key={card.key}
            type="button"
            className={[
              "lances-hub-summary__card",
              `lances-hub-summary__card--${card.tone}`,
              isActive ? "lances-hub-summary__card--active" : "",
            ]
              .filter(Boolean)
              .join(" ")}
            onClick={() => onSelectTab?.(card.key)}
            disabled={loading}
          >
            <Box className="lances-hub-summary__top">
              <span
                className={`lances-hub-summary__icon lances-hub-summary__icon--${card.tone}`}
              >
                <Icon fontSize="small" />
              </span>
              <Typography className="lances-hub-summary__value">{value}</Typography>
            </Box>
            <Typography className="lances-hub-summary__label">{card.label}</Typography>
            <Typography className="lances-hub-summary__hint">{card.hint}</Typography>
          </button>
        );
      })}
    </Box>
  );
}
